import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ["display"]
  
  connect() {
    //console.log(this.displayTarget.innerHTML)
    this.startTimer()
  }

  disconnect() {
    this.stopTimer()
  }

  startTimer() {
    let startTime = Date.now();
    let element = this.displayTarget;
    this.timerInterval = setInterval(() => {
        let elapsedTime = Date.now() - startTime;

        let diffInHrs = elapsedTime / 3600000;
        let hh = Math.floor(diffInHrs);
        let diffInMin = (diffInHrs - hh) * 60;
        let mm = Math.floor(diffInMin);
        let diffInSec = (diffInMin - mm) * 60;
        let ss = Math.floor(diffInSec);
        let formattedMM = mm.toString().padStart(2, "0");
        let formattedSS = ss.toString().padStart(2, "0");

        element.innerHTML = (`${formattedMM}:${formattedSS}`);
    }, 100);
  }

  stopTimer(){
      clearInterval(this.timerInterval);
      this.displayTarget.innerHTML = '00:00'
  }
}